import { formNavigationTheme } from './FormNavigation/theme';
import { formSectionTheme } from './FormSection/theme';

export const formTheme = {
  navigationItem: formNavigationTheme,
  section: formSectionTheme,
};
